<!-- start features -->
<section class="section intro-section pb-0">
    <div class="container">
        <div class="row align-items-center justify-content-lg-between justify-content-center gy-4">
            <div class="col-lg-5 col-sm-7">
                <div class="about-img-section mb-5 mb-lg-0 text-center">
                    <div class="card rounded shadow-lg inquiry-box d-none d-lg-block">
                        <div class="card-body d-flex align-items-center">
                            <div class="avatar-sm flex-shrink-0 me-3">
                                <div class="avatar-title bg-secondary-subtle text-secondary rounded-circle fs-18">
                                   <!-- svg from assets -->
                                <img src="assets/images/flexible.svg" alt="" class="img-fluid mx-auto rounded-3" />
                                </div>
                            </div>
                            <h5 class="fs-15 lh-base mb-0">{{'homepage.homeMaster.learnFreeAnyTime'|translate}}</h5>
                        </div>
                    </div>
                    <img src="assets/images/about.jpg" alt="" class="img-fluid mx-auto rounded-3" />
                </div>
            </div>
            <div class="col-lg-6" style="margin-bottom: 90px;">
                <div class="text-muted">
                    <h1 class="mb-3 lh-base fw-semibold"><span class="text-primary"> {{ 'general.anatalebPlatform' | translate }}</span></h1>
                    <p class="ff-secondary fs-22 mb-4">{{ 'homepage.homeMaster.aboutAnataleb' | translate }}</p>

                    <div class="vstack gap-2 mb-4 pb-1">
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 me-2">
                                <div class="avatar-xs icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle h2">
                                        <i class="ri-check-fill"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-0  fs-22">{{'homepage.homeMaster.anatalebService1'|translate}}</p>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 me-2">
                                <div class="avatar-xs icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle h2">
                                        <i class="ri-check-fill"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-0 fs-22">{{'homepage.homeMaster.anatalebService2'|translate}}</p>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 me-2">
                                <div class="avatar-xs icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle h2">
                                        <i class="ri-check-fill"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-0 fs-22">{{'homepage.homeMaster.anatalebService3'|translate}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </div>
    <!-- end container -->
</section>
<!-- end features -->